import React from 'react';
import MainLayout from '../../layouts/MainLayout';

export default function JobBoardComingSoon() {
  return (
    <>
      <MainLayout>
        <div className='text-white'>
          <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>About Think5Whys Job Board</h3>
        </div>
        <div>
          <div className='text-lg mt-1 mx-8 text-white'>
            <p className='text-yellow-200'>
              <span role="img" aria-label="rocket">🚀</span> Exciting News! Something Amazing Is On Its Way.
              <br /><br />
              Dear User,
              <br /><br />
              We are thrilled to share that something extraordinary is in the works! Our team has been working tirelessly to bring you an innovative and game-changing experience that will redefine the way you seek job, assignments as well as search for the right candidate to accomplish your BPM work.
              <br /><br />
              <span role="img" aria-label="star">🌟</span> What's Coming:
              Stay tuned for an unparalleled platform & service experience that is designed with you in mind. We have poured our passion into every detail to ensure this is something truly special.
              <ul className="list-disc ml-8">
                <li><strong>Job Board:</strong> Explore available job opportunities.</li>
                <li><strong>Seek a Job:</strong> Find and apply for jobs.</li>
                <li><strong>Post a Job:</strong> Post job opportunities for candidates.</li>
                <li><strong>Instant Jobs:</strong> Access jobs with immediate availability.</li>
                <li><strong>Instant Interaction:</strong> Real-time communication or interaction features.</li>
                <li><strong>Feedbacks & Ratings:</strong> Provide and view feedback on jobs or candidates.</li>
                <li><strong>Verified Recruiters:</strong> Ensures credibility with verified recruiter profiles.</li>
                <li><strong>Certified Freelancers:</strong> Indicates freelancers with recognized certifications.</li>
                <li><strong>Job Work Diary:</strong> Track and manage job-related activities.</li>
                <li><strong>Time Tracker:</strong> Monitor and log time spent on jobs.</li>
                <li><strong>BPM Consultants:</strong> Connect with consultants specializing in BPM.</li>
                <li><strong>Experts Services:</strong> Access services provided by industry experts.</li>
                <li><strong>Intern Positions:</strong> Explore internship opportunities.</li>
                <li><strong>Retail Positions:</strong> Find positions in the retail sector.</li>
                <li><strong>MSME Support:</strong> Support services for Micro, Small and Medium Enterprises.</li>
                <li><strong>Job Payments:</strong> Information on job-related payments.</li>
                <li><strong>Job Payment Protection:</strong> Assurance or protection measures for job payments.</li>
              </ul>
              <br /><br />
              <span role="img" aria-label="calendar">🗓️</span> Countdown:
              The excitement is building, and we can't wait to unveil it. Join us on this thrilling journey as we count down the days until the big reveal.
              <br /><br />
              <span role="img" aria-label="email">📧</span> Stay Connected:
              Want to be the first to know when we launch? Subscribe to our newsletter and be part of an exclusive group that gets early access and exciting updates.
              <br /><br />
              <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Subscribe Now
              </button>
              <br />
              Thank you for your continued support. 
              <br />
              We can't wait to share this moment with you!
              <br />
              Best regards,
              The Think5Whys@processifyd.com Team
            </p>
            {/* <p>
            <p className='text-yellow-200'><strong>Event: Eventful Horizons</strong></p>
            An event is a gathering or occurrence, often involving multiple people.<br/> 
            In Think5Whys, you manage your own event list or other events important to you.
          </p>
          <p><br/>
            <p className='text-yellow-200'><strong>Memory / Recollection: Memoirs of Memories</strong></p> 
            A memory is a recollection of past experiences stored in the mind.<br/>
            In Think5Whys, you manage your own memory list.
          </p>
          <p><br/>
            <p className='text-yellow-200'><strong>Experience: Journey of Experience</strong></p> 
            An experience is a broader term encompassing various moments and encounters.<br/>
            In Think5Whys, you manage your own experience list.
          </p><br/>
          <p>
            <p className='text-yellow-200'><strong>Invitation: Invitations to Joy</strong></p> 
            An invitation is a request to attend a specific event or activity. <br/>
            In Think5Whys, you manage your own event list or events you have or wish to attend.
          </p><br/>
          <p>
            <p className='text-yellow-200'><strong>Gratitude: Gratitude's Tapestry</strong></p> 
            Gratitude is the state of being thankful or appreciative. <br/>
            In Think5Whys, you manage your own gratitude list and share a short thankyou message.
          </p><br/>
          <p>
            <p className='text-yellow-200'><strong>Empathy: Empathy's Embrace</strong></p> 
            Empathy is the ability to understand and share the feelings of others. <br/>
            In Think5Whys, you manage your own empathy list and share a short empathy message.
          </p><br/>
          <p>
            <p className='text-yellow-200'><strong>Sympathy: Sympathetic Echoes</strong></p> 
            Sympathy is Recognizing and expressing compassion for others' challenges without shared emotions. <br/>
            In Think5Whys, you manage your own sympathy list and share a short message.
          </p> */}
          </div>
        </div>
      </MainLayout>
    </>
  );
}
